var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80772 14.2486C10.2612 14.2486 13.0608 11.309 13.0608 7.68288C13.0608 4.05675 10.2612 1.11719 6.80772 1.11719C3.35427 1.11719 0.554688 4.05675 0.554688 7.68288C0.554688 11.309 3.35427 14.2486 6.80772 14.2486Z",
    stroke: "#CEAF7F",
    strokeWidth: 0.907034,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42073 13.2086L2.33984 21.7534L6.8063 18.9395L11.2728 21.7534L10.1919 13.1992",
    stroke: "#CEAF7F",
    strokeWidth: 0.907034,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWin);
export default __webpack_public_path__ + "static/media/win.d37dd814196e0e5f7fa08ab085c36fd0.svg";
export { ForwardRef as ReactComponent };